//==============================================================================
// Test Constants
//
// Consolidated list of test enums and constants reused across different modules
//==============================================================================

export enum TestType {
    iowa = 'Iowa',
    iowaCogAt = 'Iowa with CogAT',
    stanford = 'Stanford',
    both = 'Iowa,Stanford'
}

export enum AppEducation {
    highschool = 'High School Diploma or GED',
    associates = 'Associate\'s Degree',
    bachelors = 'Bachelor\'s Degree',
    masters = 'Master\'s Degree',
    doctoral = 'Doctoral Degree'
}

export enum AppStanfordLocation {
    default = 'US/CA/UK',
    other = 'Other'
}

export enum AppStatus {
    approved = 0,
    pending = 1,
    rejected = 2,
    suspended = 3,
    notApplied = 4
}

export enum SessionStatus {
    open = 0,
    closed = 1
}

export const appEducationMap: {[key: string]: string[]} = {
    [TestType.iowa]: [
        AppEducation.highschool,
        AppEducation.associates,
        AppEducation.bachelors,
        AppEducation.masters,
        AppEducation.doctoral
    ],
    [TestType.stanford]: [
        AppEducation.bachelors,
        AppEducation.masters,
        AppEducation.doctoral
    ],
    [TestType.both]: [
        AppEducation.bachelors,
        AppEducation.masters,
        AppEducation.doctoral
    ]
};

export const timezoneDefault: string = 'America/New_York';
